import { ITranslations } from 'types/common';
import { PointsLogsFiltersFormTransFields } from './types';
import en from 'translations/en/pointsLogsFilters.json';
import pl from 'translations/pl/pointsLogsFilters.json';
import sl from 'translations/sl/pointsLogsFilters.json';

export const pointsLogsFiltersFormTranslations: ITranslations<PointsLogsFiltersFormTransFields> = {
  name: 'pointsLogsFilters',
  en,
  pl,
  sl,
};
